import React from "react";
import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";
import Login from "./pages/Login/Login";
import AdminConsole from "./pages/AdminConsole/AdminConsole";
import Loader from "./components/Loader/Loader";
import authService from "./services/auth.service";
import "./App.scss";

import { ADMIN_ROUTES, DEFAULT_PATH } from "./routes/config";

const AuthCallback: React.FC = () => {
  const [error, setError] = React.useState<string>("");

  React.useEffect(() => {
    const run = async () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get("code");

      if (!code) {
        setError("Authorization code was not provided.");
        return;
      }

      try {
        const response = await authService.exchangeAuthorizationCode(code);
        authService.saveUser(response.user);
        window.location.replace(DEFAULT_PATH);
      } catch (requestError: any) {
        setError(
          requestError.response?.data?.message || "Authorization callback failed.",
        );
      }
    };

    void run();
  }, []);

  if (error) {
    return (
      <div className="app">
        <Loader message={error} />
      </div>
    );
  }

  return <Loader message="Completing sign in..." />;
};

const App: React.FC = () => {
  return (
    <Router>
      <div className="app">
        <Routes>
          <Route path="/" element={<Navigate to={DEFAULT_PATH} replace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          
          {ADMIN_ROUTES.map(route => (
            <Route 
              key={route.path} 
              path={route.path} 
              element={<AdminConsole />} 
            />
          ))}

          <Route path="/console" element={<Navigate to={DEFAULT_PATH} replace />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
